import delivery from './delivery'

export default [
  ...delivery,
]
